import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_toggle_activation_site",
  ref: "toggleActivationSiteModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Deseja realmente desativar o Consensu deste site?", -1)
const _hoisted_9 = { class: "text-gray-400 text-hover-primary mb-2" }
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = { class: "indicator-label" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Por favor, espere..."),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.getModalLabel) + "?", 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.site.website), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn", _ctx.site.status.account == 'active' ? 'btn-danger' : 'btn-success']),
            ref: "submitButtonRef",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateSite && _ctx.updateSite(...args))),
            type: "submit"
          }, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getModalLabel), 1),
            _hoisted_12
          ], 2)
        ])
      ])
    ])
  ], 512))
}